<template>
  <page>
    <v-card>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-card-title>
        <div>
          <div class="headline">ISO Country Listing</div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="index" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.isoCty }}</td>
          <td class="text-xs-left">{{ props.item.isoCtyDesc }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn color="primary" dark class="mb-2" @click="doNew">New ISO Country<v-icon>mdi-plus</v-icon></v-btn>
    </v-card>
    <v-dialog v-model="ctyDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ labels.valueFormTitle }}</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <form>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs6 v-if="newCty">
                  <v-text-field v-model="ctyForm.isoCty" :label="labels.isoCty" :error-messages="errors.collect('isoCty')" data-vv-name="isoCty" :data-vv-as="labels.isoCty" v-validate="'required|param|max:2'"></v-text-field>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{labels.isoCty}}</v-subheader>
                  <div class="subheading">{{ctyForm.isoCty}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="ctyForm.isoCtyDesc" :label="labels.isoCtyDesc" :error-messages="errors.collect('isoCtyDesc')" data-vv-name="isoCtyDesc" :data-vv-as="labels.isoCtyDesc" v-validate="'required|entry|max:60'"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doDelete">
      Are you sure you want to delete the selected item?
      <div class="title">{{selectedId.text}}</div>
    </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      headers: [
        { text: 'Country Code', align: 'left', value: 'isoCty' },
        { text: 'Country Code Description', align: 'left', value: 'isoCtyDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        valueFormTitle: 'ISO Country Details',
        isoCty: 'Country Code',
        isoCtyDesc: 'Country Code Description'
      },
      ctyForm: {
        isoCty: null,
        isoCtyDesc: null
      },
      filters: {
        isoCty: null,
        isoCtyDesc: null
      },
      ctyDialog: null,
      newCty: null,
      sumbitting: undefined,
      selectedId: {
        id: null,
        text: null
      },
      promptRemove: false
    }
  },
  computed: {
    misc() {
      return this.$store.state.misc.menu
    }
  },
  methods: {
    async init() {
      this.loading = true
      this.selectedId.id = null
      this.selectedId.text = null
      const apiURI = this.misc.getISOCtys
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((isoCty) => {
              const convertCty = {
                isoCty: isoCty.isoCty,
                isoCtyDesc: isoCty.isoCtyDesc
              }
              this.items.push(convertCty)
            })
            this.loading = false
          }
        } catch (error) {
          this.loading = false
        }
      } else {
        this.loading = false
      }
    },
    async doInit() {
      await this.$store.dispatch('miscInit')
      this.init()
    },
    async doReview(data) {
      this.ctyDialog = true
      this.newCty = false
      const apiURI = this.misc.getISOCty
      const expand = {
        cty: data.item.isoCty
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.ctyForm.isoCty = data.isoCty.isoCty
          this.ctyForm.isoCtyDesc = data.isoCty.isoCtyDesc
        }
        this.ctyDialog = true
      }
    },
    doNew() {
      this.resetValidator()
      this.resetMessages()
      this.newCty = true
      this.ctyDialog = true
    },
    doClose() {
      this.resetValidator()
      this.resetMessages()
      this.newCty = false
      this.ctyDialog = false
      this.ctyForm.isoCty = null
      this.ctyForm.isoCtyDesc = null
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newCty) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.misc.createISOCty
      if (apiURI) {
        this.sumbitting = true
        try {
          const result = await this.$http.post(apiURI, this.ctyForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doClose()
            console.log(data)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
            console.log(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.misc.updateISOCty
      if (apiURI) {
        this.sumbitting = true
        try {
          const result = await this.$http.put(apiURI, this.ctyForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doPromptRemove(isoCty) {
      this.resetMessages()
      this.selectedId.id = isoCty.isoCty
      this.selectedId.text = isoCty.isoCty + ' - ' + isoCty.isoCtyDesc
      this.promptRemove = true
    },
    doDelete() {
      const apiURI = this.misc.deleteISOCty
      if (apiURI) {
        const expand = {
          cty: this.selectedId.id
        }
        this.$http.delete(expandURI(apiURI, expand)).then(result => {
          const data = result.data
          this.notify(data)
          this.init()
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
